<mat-form-field>
    <mat-label>{{label}}</mat-label>
    <input matInput (input)="onSearch($event)" [(ngModel)]="value">
</mat-form-field>
